import { render, staticRenderFns } from "./Ownership.vue?vue&type=template&id=6f1d51d8&scoped=true"
import script from "./Ownership.vue?vue&type=script&lang=js"
export * from "./Ownership.vue?vue&type=script&lang=js"
import style0 from "./Ownership.vue?vue&type=style&index=0&id=6f1d51d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1d51d8",
  null
  
)

export default component.exports